// extracted by mini-css-extract-plugin
export default {"resetZoomPan":"ResetZoomPan_resetZoomPan__DJum+"};